import './Cart.css';

function Cart(props) {
  const {
    quantity = 0,
    basketVisibility = Function.prototype,
    isBasketVisible = true,
    orderListVisibility = Function.prototype
  } = props;
  console.log('quantity', quantity);
  
  return isBasketVisible ? (
		<div
			className={`cart blue darken-4 white-text ${
				!isBasketVisible ? 'hidden' : ''
			}`}
		>
			<i
				className='material-icons'
				onClick={orderListVisibility}
			>
				shopping_cart
			</i>
			{quantity ? (
				<span className='cart-quantity'>{quantity}</span>
			) : null}
			<i
				className='material-icons close-cart tiny'
				onClick={() => basketVisibility()}
			>
				close
			</i>
		</div>
  ) : null;
}

export { Cart };